import { Fill, Stroke, Style, Icon as IconOL, Text } from "ol/style";

const poiStyle = {
  admCenter: new Style({
    image: new IconOL({
      src: 'img/AdmCenter.svg',
      scale: 0.7,
    }),
  }),
  university: new Style({
    image: new IconOL({
      src: 'img/University.svg',
      scale: 0.7,
    }),
  }),
  industry: new Style({
    image: new IconOL({
      src: 'img/Industry.svg',
      scale: 0.7,
    }),
  }),
  hospital: new Style({
    image: new IconOL({
      src: 'img/Hospital.svg',
      scale: 0.7,
    }),
  }),
  security: new Style({
    image: new IconOL({
      src: 'img/Security.svg',
      scale: 0.7,
    }),
  }),
  selectedPoi: new Style({
		text: new Text({
			scale: 1.3,
			fill: new Fill({ color: 'rgba(0,0,0,1)', width: 5 }),
			stroke: new Stroke({ color: 'rgba(255,255,255,1)', width: 2 }),
		}),
	}),
};

export { poiStyle };